import ScheduleList from '@src/components/template/admin/BookingPlaces/ScheduleList';
import { useParams } from 'react-router-dom';

export default function PlaceScheduleList() {
  const { itemId } = useParams();
  return <ScheduleList itemId={itemId || ''}></ScheduleList>;
}
